import { render, staticRenderFns } from "./IncidentReportProgressTracker.vue?vue&type=template&id=70e80348&scoped=true"
import script from "./IncidentReportProgressTracker.vue?vue&type=script&lang=js"
export * from "./IncidentReportProgressTracker.vue?vue&type=script&lang=js"
import style0 from "./IncidentReportProgressTracker.vue?vue&type=style&index=0&id=70e80348&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e80348",
  null
  
)

export default component.exports